class SocialMedia {
    constructor() {
        this.social = document.querySelector('.ecf-float-social');
        this.socialItem = document.querySelectorAll('.ecf-float-social__item');
        this.masterHead = document.querySelector('#ecf-masthead-gen');
        this.contentBox = document.querySelector('.single-blog-press-template__content')
        this.masterHeadProperty = {
            height : 0,
            content: 0,
        }
    }

    scrollEvent(){
        let {height,content} = this.masterHeadProperty
        let {social} = this
        if(document.documentElement.scrollTop > height && document.documentElement.scrollTop < content + 150){
            social.querySelector('.ecf-float-social__container').classList.add('fixed')
        }else{
            social.querySelector('.ecf-float-social__container').classList.remove('fixed')
        }
    }

    init(){
        let {social, socialItem ,masterHead, contentBox} = this
        if(social && masterHead && contentBox){
            this.masterHeadProperty.height = masterHead.clientHeight
            this.masterHeadProperty.content = contentBox.clientHeight
            window.addEventListener('scroll',() =>{
                this.scrollEvent()
            })
        }
        // console.log(socialItem);
        // socialItem.forEach(item => {
        //     item.addEventListener('mouseover',()=>{
        //         item.classList.add("active");
        //     })
        //     item.addEventListener('mouseout',()=>{
        //         item.classList.remove("active");
        //     })
        // });
    }
    
}

export default SocialMedia